import { Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { useCallback } from "react";

const RegistrationAccordionToggle = ({
	children,
	className,
	eventKey,
	handleToggle
}) => {

	const onClick = useCallback(() => handleToggle(eventKey), [handleToggle]);

	return (
		<Button
			className={className}
			onClick={onClick}
		>
			{children}
		</Button>
	);
};

RegistrationAccordionToggle.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	eventKey: PropTypes.string.isRequired,
	handleToggle: PropTypes.func.isRequired
};

RegistrationAccordionToggle.defaultProps = {
	className: ""
};

export default RegistrationAccordionToggle;
